// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConfirmationPopup-space1-NVEKx {
	margin-bottom: 6px !important;
}

.ConfirmationPopup-space2-RgxxZ {
	margin-bottom: 12px !important;
}

.ConfirmationPopup-space3-kl6SH {
	margin-bottom: 18px !important;
}

.ConfirmationPopup-space4-DDAyb {
	margin-bottom: 24px !important;
}

.ConfirmationPopup-space5-YfLgf {
	margin-bottom: 30px !important;
}

.ConfirmationPopup-space6-oNbzp {
	margin-bottom: 36px !important;
}

.ConfirmationPopup-space7-p9wBc {
	margin-bottom: 42px !important;
}

.ConfirmationPopup-spaceTop8-nF7EV {
	margin-bottom: 48px !important;
}

.ConfirmationPopup-spaceTop1-Zr7We {
	margin-top: 6px !important;
}

.ConfirmationPopup-spaceTop2-e6HYz {
	margin-top: 12px !important;
}

.ConfirmationPopup-spaceTop3-atvKK {
	margin-top: 18px !important;
}

.ConfirmationPopup-spaceTop4-wlm0K {
	margin-top: 24px !important;
}

.ConfirmationPopup-spaceTop5-EcfAS {
	margin-top: 30px !important;
}

.ConfirmationPopup-spaceTop6-QRGta {
	margin-top: 36px !important;
}

.ConfirmationPopup-spaceTop7-eYEwX {
	margin-top: 42px !important;
}

.ConfirmationPopup-spaceTop8-nF7EV {
	margin-top: 48px !important;
}

.ConfirmationPopup-noMargin-MViyY {
	margin: 0px !important;
}

.ConfirmationPopup-padding1-kDy6S {
	padding-bottom: 6px !important;
}

.ConfirmationPopup-padding2-bjQHc {
	padding-bottom: 12px !important;
}

.ConfirmationPopup-padding3-HFZtS {
	padding-bottom: 18px !important;
}

.ConfirmationPopup-padding4-UATxO {
	padding-bottom: 24px !important;
}

.ConfirmationPopup-padding5-q8XvP {
	padding-bottom: 30px !important;
}

.ConfirmationPopup-padding6-KVHdd {
	padding-bottom: 36px !important;
}

.ConfirmationPopup-padding7-Kpugm {
	padding-bottom: 42px !important;
}

.ConfirmationPopup-paddingTop1-E2gB_ {
	padding-top: 6px !important;
}

.ConfirmationPopup-paddingTop2-GXOv_ {
	padding-top: 12px !important;
}

.ConfirmationPopup-paddingTop3-NTt_6 {
	padding-top: 18px !important;
}

.ConfirmationPopup-paddingTop4-vL7TB {
	padding-top: 24px !important;
}

.ConfirmationPopup-paddingTop5-tqNhZ {
	padding-top: 30px !important;
}

.ConfirmationPopup-paddingTop6-B4XlJ {
	padding-top: 36px !important;
}

.ConfirmationPopup-paddingTop7-Tp62p {
	padding-top: 42px !important;
}

.ConfirmationPopup-noPadding-gtj0O {
	padding: 0px !important;
}

.ConfirmationPopup-textBold-WMWst {
	font-weight: 500 !important;
}

.ConfirmationPopup-textBolder-f3n1g {
	font-weight: 700 !important;
}

.ConfirmationPopup-textNormal-_HBHN {
	font-weight: normal !important;
}

.ConfirmationPopup-spaceBottom20-NTisN {
	margin-bottom: 20px;
}

.ConfirmationPopup-spaceBottom10-jlQ1k {
	margin-bottom: 10px;
}

.ConfirmationPopup-marginNone-uysa_ {
	margin: 0;
}

.ConfirmationPopup-spaceBottom15-kpqLE {
	margin-bottom: 15px;
}

.ConfirmationPopup-marginTopNone-xyUWR {
	margin-top: 0;
}

.ConfirmationPopup-spaceTop11-zkmSl {
	margin-top: 11px;
}

.ConfirmationPopup-spaceTop21-Tn2_7 {
	margin-top: 21px;
}

.ConfirmationPopup-spaceTop20-nNQCt {
	margin-top: 20px;
}

.ConfirmationPopup-spaceTop10-jO3Xy {
	margin-top: 10px;
}

/*New Design Text Colors */

.ConfirmationPopup-textDarkBlue-G81UW {
	color: rgb(20, 39, 94) !important;
}

.ConfirmationPopup-textLightBlue-EsI6f {
	color: rgb(57, 87, 106) !important;
}

.ConfirmationPopup-textLightSandleGreen-wdjTq {
	color: rgb(76, 86, 41) !important;
}

.ConfirmationPopup-textLightBrown-PT4QA {
	color: rgb(115, 79, 33) !important;
}

.ConfirmationPopup-textMediumMaroon-IvAJA {
	color: rgb(87, 37, 51) !important;
}

.ConfirmationPopup-textBrown-pDi7k {
	color: rgb(160, 47, 24) !important;
}

.ConfirmationPopup-textMaroon-VpM7w {
	color: rgb(155, 49, 67) !important;
}

.ConfirmationPopup-textDarkBrown-zmQNZ {
	color: rgb(83, 18, 16) !important;
}

.ConfirmationPopup-textMediumBrown-VW2_0 {
	color: rgb(142, 28, 10) !important;
}

.ConfirmationPopup-textSkyBlue-cljWm {
	color: rgb(37, 117, 141) !important;
}

.ConfirmationPopup-textGray-E3Khk {
	color: rgb(77, 65, 51) !important;
}

.ConfirmationPopup-root-PdNoc {
	padding: 25px;
}

.ConfirmationPopup-logInModalContainer-kVI7C {
	width: 468px;
}

.ConfirmationPopup-logInModalBody-TSpWS {
	padding: 0px;
}

.ConfirmationPopup-confirmationPopupBodyText-jrYhj {
	font-size: 16px;
	line-height: 28px;
	font-weight: 400;
	margin-bottom: 0;
}

.ConfirmationPopup-confirmationPopupFooterBtnGrp-Sq7xP {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: end;
	    -ms-flex-pack: end;
	        justify-content: flex-end;
	margin-top: 30px;
	gap: 15px;
	text-align: start;
}

@media (max-width: 767px) {
	.ConfirmationPopup-logInModalContainer-kVI7C {
		width: auto;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/Common/ConfirmationPopup/ConfirmationPopup.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA;CACC,aAAa;AACd;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,qBAAyB;KAAzB,kBAAyB;SAAzB,yBAAyB;CACzB,gBAAgB;CAChB,SAAS;CACT,iBAAiB;AAClB;;AAEA;CACC;EACC,WAAW;CACZ;AACD","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../../components/helpers.css';\n\n.root {\n\tpadding: 25px;\n}\n\n.logInModalContainer {\n\twidth: 468px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n.confirmationPopupBodyText {\n\tfont-size: 16px;\n\tline-height: 28px;\n\tfont-weight: 400;\n\tmargin-bottom: 0;\n}\n\n.confirmationPopupFooterBtnGrp {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tmargin-top: 30px;\n\tgap: 15px;\n\ttext-align: start;\n}\n\n@media (max-width: 767px) {\n\t.logInModalContainer {\n\t\twidth: auto;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ConfirmationPopup-space1-NVEKx`,
	"space2": `ConfirmationPopup-space2-RgxxZ`,
	"space3": `ConfirmationPopup-space3-kl6SH`,
	"space4": `ConfirmationPopup-space4-DDAyb`,
	"space5": `ConfirmationPopup-space5-YfLgf`,
	"space6": `ConfirmationPopup-space6-oNbzp`,
	"space7": `ConfirmationPopup-space7-p9wBc`,
	"spaceTop8": `ConfirmationPopup-spaceTop8-nF7EV`,
	"spaceTop1": `ConfirmationPopup-spaceTop1-Zr7We`,
	"spaceTop2": `ConfirmationPopup-spaceTop2-e6HYz`,
	"spaceTop3": `ConfirmationPopup-spaceTop3-atvKK`,
	"spaceTop4": `ConfirmationPopup-spaceTop4-wlm0K`,
	"spaceTop5": `ConfirmationPopup-spaceTop5-EcfAS`,
	"spaceTop6": `ConfirmationPopup-spaceTop6-QRGta`,
	"spaceTop7": `ConfirmationPopup-spaceTop7-eYEwX`,
	"noMargin": `ConfirmationPopup-noMargin-MViyY`,
	"padding1": `ConfirmationPopup-padding1-kDy6S`,
	"padding2": `ConfirmationPopup-padding2-bjQHc`,
	"padding3": `ConfirmationPopup-padding3-HFZtS`,
	"padding4": `ConfirmationPopup-padding4-UATxO`,
	"padding5": `ConfirmationPopup-padding5-q8XvP`,
	"padding6": `ConfirmationPopup-padding6-KVHdd`,
	"padding7": `ConfirmationPopup-padding7-Kpugm`,
	"paddingTop1": `ConfirmationPopup-paddingTop1-E2gB_`,
	"paddingTop2": `ConfirmationPopup-paddingTop2-GXOv_`,
	"paddingTop3": `ConfirmationPopup-paddingTop3-NTt_6`,
	"paddingTop4": `ConfirmationPopup-paddingTop4-vL7TB`,
	"paddingTop5": `ConfirmationPopup-paddingTop5-tqNhZ`,
	"paddingTop6": `ConfirmationPopup-paddingTop6-B4XlJ`,
	"paddingTop7": `ConfirmationPopup-paddingTop7-Tp62p`,
	"noPadding": `ConfirmationPopup-noPadding-gtj0O`,
	"textBold": `ConfirmationPopup-textBold-WMWst`,
	"textBolder": `ConfirmationPopup-textBolder-f3n1g`,
	"textNormal": `ConfirmationPopup-textNormal-_HBHN`,
	"spaceBottom20": `ConfirmationPopup-spaceBottom20-NTisN`,
	"spaceBottom10": `ConfirmationPopup-spaceBottom10-jlQ1k`,
	"marginNone": `ConfirmationPopup-marginNone-uysa_`,
	"spaceBottom15": `ConfirmationPopup-spaceBottom15-kpqLE`,
	"marginTopNone": `ConfirmationPopup-marginTopNone-xyUWR`,
	"spaceTop11": `ConfirmationPopup-spaceTop11-zkmSl`,
	"spaceTop21": `ConfirmationPopup-spaceTop21-Tn2_7`,
	"spaceTop20": `ConfirmationPopup-spaceTop20-nNQCt`,
	"spaceTop10": `ConfirmationPopup-spaceTop10-jO3Xy`,
	"textDarkBlue": `ConfirmationPopup-textDarkBlue-G81UW`,
	"textLightBlue": `ConfirmationPopup-textLightBlue-EsI6f`,
	"textLightSandleGreen": `ConfirmationPopup-textLightSandleGreen-wdjTq`,
	"textLightBrown": `ConfirmationPopup-textLightBrown-PT4QA`,
	"textMediumMaroon": `ConfirmationPopup-textMediumMaroon-IvAJA`,
	"textBrown": `ConfirmationPopup-textBrown-pDi7k`,
	"textMaroon": `ConfirmationPopup-textMaroon-VpM7w`,
	"textDarkBrown": `ConfirmationPopup-textDarkBrown-zmQNZ`,
	"textMediumBrown": `ConfirmationPopup-textMediumBrown-VW2_0`,
	"textSkyBlue": `ConfirmationPopup-textSkyBlue-cljWm`,
	"textGray": `ConfirmationPopup-textGray-E3Khk`,
	"root": `ConfirmationPopup-root-PdNoc`,
	"logInModalContainer": `ConfirmationPopup-logInModalContainer-kVI7C`,
	"logInModalBody": `ConfirmationPopup-logInModalBody-TSpWS`,
	"confirmationPopupBodyText": `ConfirmationPopup-confirmationPopupBodyText-jrYhj`,
	"confirmationPopupFooterBtnGrp": `ConfirmationPopup-confirmationPopupFooterBtnGrp-Sq7xP`
};
module.exports = ___CSS_LOADER_EXPORT___;
